import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export default function TalentCard({ profile, large = false }) {
  return (
    <Link
      to={`/profile/${profile.profile_id}`}
      className={`group pfc-card block relative overflow-hidden ${large ? "lg:col-span-2 lg:row-span-2" : ""}`}
      data-testid={`talent-card-${profile.profile_id}`}
    >
      <div className={`relative overflow-hidden ${large ? "aspect-[4/5]" : "aspect-[3/4]"}`}>
        <img
          src={profile.cover_image}
          alt={profile.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/30 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="label bg-pfc-gold text-ink-900 px-2 py-1">{profile.category}</span>
          {profile.featured && <span className="label bg-pfc-red text-white px-2 py-1">Featured</span>}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className={`font-display text-white leading-none ${large ? "text-4xl lg:text-5xl" : "text-2xl"}`}>
            {profile.name.toUpperCase()}
          </h3>
          <p className="font-sub uppercase tracking-wider text-pfc-gold text-xs mt-2 line-clamp-2">{profile.headline}</p>
          {profile.location && (
            <p className="flex items-center gap-1 text-white/60 text-xs mt-2 font-body">
              <MapPin size={12} /> {profile.location}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
